import { useEffect } from "react";
import { useAuth } from "@/lib/auth";
import { clearSentryUser, setSentryUser } from "@/lib/sentry";

// Keeps the Sentry user/org context in sync with Clerk. Mounted once inside
// <ClerkLoaded> next to InstallAuthToken; renders nothing. useAuth().orgId is
// the active organization id (null when the user has no org selected).
export function SentryIdentity(): null {
  const { isSignedIn, userId, orgId } = useAuth();

  useEffect(() => {
    if (isSignedIn && userId) {
      setSentryUser(userId, orgId ?? null);
    } else {
      clearSentryUser();
    }
  }, [isSignedIn, userId, orgId]);

  return null;
}
